import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import { Button, Stack } from '@chakra-ui/react';

import { Dialog, FormField, Input, Wysiwyg } from '~/core/shared/components';
import UnsavedModal from '~/core/shared/components/UnsavedModal.component';
import { useEmailCreateModal } from './hooks/useEmailCreateModal';
import { EmailCreateModalProps } from './types/EmailCreateModalProps';

const EmailCreateModalComponent = ({
  documentId,
  documentDefinition,
}: EmailCreateModalProps) => {
  const {
    mailToLabel,
    isCreatingEmail,
    emailCreateModalApi,
    form,
    handleClose,
    handleCloseAndReset,
    onOpenChange,
    onSubmit,
    unsavedChangesModalApi,
  } = useEmailCreateModal(documentId, documentDefinition);

  return (
    <Dialog
      header={`Email to ${mailToLabel}`}
      onOpenChange={onOpenChange}
      open={emailCreateModalApi.open}
      size="lg"
      subHeader="Send a message to the applicant via email and record as a message against the application."
    >
      <FormProvider {...form}>
        <Stack as="form" gap={4} onSubmit={form.handleSubmit(onSubmit)}>
          <FormField
            component={Input}
            label="BCC recipient"
            name="bcc"
            placeholder="Enter comma separated email addresses"
            variant="outline"
          />

          <FormField
            component={Input}
            label="Subject"
            name="subject"
            required
            variant="outline"
          />

          <FormField
            borderColor="gray.300"
            component={Wysiwyg}
            defaultValue=""
            label="Message text"
            name="content"
            required
            size="lg"
            variant="outline"
          />

          <Stack direction="row" justifyContent="end">
            <Button
              colorPalette="gray"
              fontSize="md"
              fontWeight="normal"
              onClick={handleClose}
              variant="outline"
            >
              Cancel
            </Button>
            <Button
              colorPalette="primary"
              fontSize="md"
              fontWeight="bold"
              loading={isCreatingEmail}
              type="submit"
              variant="solid"
            >
              Send to {mailToLabel}
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
      <UnsavedModal
        close={handleCloseAndReset}
        modalApi={unsavedChangesModalApi}
      />
    </Dialog>
  );
};

export const EmailCreateModal = memo(EmailCreateModalComponent);
